import React from 'react';
import moment from 'moment-timezone';
import { MenuItem, Navbar, Nav, NavItem, Glyphicon, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './assets/css/Header.css';
import AuthorizedComponent from '../AuthorizedComponent';
import { ROLES } from '../../constants';

const NavView = ({ children }) => (
    <Navbar collapseOnSelect inverse fixedTop fluid className="nav-main">
        <Navbar.Header>
            <Navbar.Brand>
                <a>
                    F<small>reight</small> T<small>racking</small> S<small>ystem</small>{' '}
                    <sup className="text-muted" title="The Excelsior Acquisition">
                        v1.7.0
                    </sup>
                </a>
            </Navbar.Brand>
            <Navbar.Toggle />
        </Navbar.Header>
        {children}
    </Navbar>
);

export default ({ user, onLogout, changeTimezone, selectedTimezone }) => {
     if (!user) {
        return <NavView/>;
    }
    const sendEmailToSupport = () => {
        const recipient = 'service.center@toyota-europe.com';
        const cc = 'ece.koscu@toyota-europe.com,ams.tlms.all@toyota-europe.com';
        const subject = encodeURIComponent('FTS Access Request');
        const body = encodeURIComponent(
            `Hello,\n\n` +
            `I would like to request access to the FTS Application for following user.\n\n` +
            `User Name: [User's Full Name]\n` +
            `Email: [User's Email]\n` +
            `FTD Team: [User's Team]\n` +
            `Do User have TARS account (Yes/No): [User's Answer]\n\n` +
            `Thank you.`
        );
        window.location.href = `mailto:${recipient}?cc=${cc}&subject=${subject}&body=${body}`;
    };
    return (
        <NavView>
            <Navbar.Collapse>
                <Nav>
                    <AuthorizedComponent requiredRoles={[ROLES.DASHBOARD_MENU]}>
                        <LinkContainer to="/dashboard">
                            <NavItem>
                                <Glyphicon glyph="th-large" />
                                <span className="navItem-text">Dashboard</span>
                            </NavItem>
                        </LinkContainer>
                    </AuthorizedComponent>
                    <AuthorizedComponent requiredRoles={[ROLES.RUN_MENU]}>
                        <LinkContainer to="/runs">
                            <NavItem>
                                <Glyphicon glyph="road" />
                                <span className="navItem-text">Runs</span>
                            </NavItem>
                        </LinkContainer>
                    </AuthorizedComponent>
                    <AuthorizedComponent requiredRoles={[ROLES.MANIFEST_MENU]}>
                        <LinkContainer to="/manifests">
                            <NavItem>
                                <Glyphicon glyph="list-alt" />
                                <span className="navItem-text">Manifests</span>
                            </NavItem>
                        </LinkContainer>
                    </AuthorizedComponent>
                    <AuthorizedComponent requiredRoles={[ROLES.REPORTS_MENU]}>
                        <NavDropdown
                            title={
                                <span>
                                    <Glyphicon glyph="tasks" />
                                    <span className="navItem-text"> Reports</span>
                                </span>
                            }
                            id="reports-nav-dropdown"
                        >
                            <LinkContainer to="/reports/rfu">
                                <MenuItem>Route Follow Up (RFU)</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/reports/kpi">
                                <MenuItem>Abnormality KPI</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/reports/planningKpi">
                                <MenuItem>Planning KPI</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/reports/ilocsDataDownload">
                                <MenuItem>Ilocs Data Download</MenuItem>
                            </LinkContainer>
                        </NavDropdown>
                    </AuthorizedComponent>
                </Nav>
                <Nav pullRight>
                    <NavDropdown
                        title={
                            <span>
                                <Glyphicon glyph="user" />
                                <span className="navItem-text"> {user.username}</span>
                            </span>
                        }
                        id="userActions"
                        className="action-container"
                    >
                        <MenuItem onClick={onLogout}>
                            <Glyphicon glyph="log-out" />Log out
                        </MenuItem>
                        <MenuItem onClick={sendEmailToSupport}>
                            <Glyphicon glyph="envelope" /> Raise access request for another user
                        </MenuItem>
                    </NavDropdown>
                </Nav>
                <Nav pullRight>
                    <NavDropdown
                        title={
                            <span>
                                <Glyphicon glyph="time" />{' '}
                                {selectedTimezone === moment.tz.guess()
                                    ? 'Local'
                                    : selectedTimezone ? 'UTC' : 'Timezone'}
                            </span>
                        }
                        id="timezoneSelector"
                        className="action-container"
                        onSelect={changeTimezone}
                    >
                        <MenuItem eventKey="UTC" active={selectedTimezone === 'UTC'}>
                            UTC
                        </MenuItem>
                        <MenuItem
                            eventKey={moment.tz.guess()}
                            active={selectedTimezone === moment.tz.guess()}
                        >
                            Local
                        </MenuItem>
                    </NavDropdown>
                </Nav>
            </Navbar.Collapse>
        </NavView>
    );
};
